import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { imgPath } from "../../utils/imagePath";
import PropTypes from "prop-types";

const Details = (props) => {

  const { userdata } = props;

  const prepareHtml = (description = "") => ({
    __html: description,
  });

  return (

    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="details-modal-header"></Modal.Header>
      <Modal.Body>
        <Row className="mentor_detail">
          <Col md={4}>
            <div className="mentor_pic">
              <img src={userdata.image} alt="user" />
              <div className="mentor_name">
                <h3>{userdata.full_name}</h3>
                <h5>
                  <span>{userdata.position}</span>
                  {userdata.organization}
                </h5>
                <h5>
                  <span></span>
                  {userdata.main_area}
                </h5>
              </div>
            </div>
          </Col>
          <Col md={8}>
            <h2>About me</h2>
            <p dangerouslySetInnerHTML={prepareHtml(userdata.about)}></p>
            <div className="profile_btn">
              <a
                href={userdata.linkedin}
                className="link_btn btn m-0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={imgPath + "linkedin.png"}
                  className="me-2 bg-white"
                  alt="LinkedIn"
                />{" "}
                Linkedin Profile
              </a>
            </div>

          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

Details.propTypes = {
  userdata: PropTypes.shape({
    full_name: PropTypes.string,
    position: PropTypes.string,
    organization: PropTypes.string,
    main_area: PropTypes.string,
    about: PropTypes.string,
    linkedin: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
};

export default Details;
